<div class="flex gap-lg">
  @if (isCentral()) {
    <div class="flex items-center text-neutral-900">
      <lib-ibusiness-default-banner iconClass="w-44 h-10 object-contain" />
    </div>
  } @else {
    <a
      class="font-main-en no-underline flex items-center text-xl rtl:text-base font-semibold text-neutral-900"
      [routerLink]="'/'">
      @if (selectedWorkspace()?.images?.banner?.url) {
        <img
          [src]="selectedWorkspace()?.images?.banner?.url ?? ''"
          class="w-44 h-10 object-contain"
          [alt]="
            selectedWorkspace()?.name ??
            selectedWorkspace()?.slug ??
            (projectName() | transloco)
          " />
      } @else {
        <lib-ibusiness-default-banner iconClass="w-44 h-10 object-contain" />
      }
    </a>
  }
</div>
